// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_ff","galleryItem_borderTopRadius":"c-p_fg","galleryItem__image":"c-p_fh"};